module.exports = __webpack_public_path__ + "img/attend_main3.930cee8b.png";